import {Component} from "@angular/core";

@Component({
    selector: "fui-page-header-nav",
    template: "<ng-content></ng-content>",
    standalone: false
})
export class FUIPageHeaderNavComponent {
}
